<div class="scd-ml-comparision__chart-color-outer">
    <div *ngFor="let item of autoMl.iterationSet" class="scd-ml-comparision__chart-color">
      <span [style]="'background-color: '+item.color"></span>
      <div class="text">{{item.name}}</div>
    </div>
    <!-- <div class="scd-ml-comparision__chart-color">
      <span style="background-color: #807aed"></span>
      Iteration 1
    </div>
    <div class="scd-ml-comparision__chart-color">
      <span style="background-color: #807aed"></span>
      Iteration 1
    </div>
    <div class="scd-ml-comparision__chart-color">
      <span style="background-color: #807aed"></span>
      Iteration 1
    </div> -->
  </div>
<div class="bar-chart">
    <div class="bar-chart__vertical-txt">{{titlechart}}</div>
    <div class="bar-chart__yaxis">
        
        <div *ngFor="let item of yAxis" class="bar-chart__yaxis__count">
            {{rangeArr(item)}}
        </div>
    </div>
    <div class="bar-chart__chart">
        <div class="bar-chart__chart__wrap">
            <div class="bar-chart__chart-bg"></div>
            <div class="bar-chart__chart__wrap__group" *ngFor="let grp of barData;let i=index">
                <div class="p-r">
                    <div class="bar-chart__chart__wrap__group">
                        <div class="bar-chart__chart__wrap__group__bar copy" *ngFor="let bar of barData[i]" [style.height.px]="height/maxValue*bar.value" [style.background]="bar.color" [style.width.px]="barwidth">
                            <span data-text-end="Copied!"  class="tooltip">
                                <div class="round" [style.background]="bar.color" ></div>
                                {{bar.value}}
                            </span>
                            <!-- <p hidden #lazy [countUp]="height/maxValue*bar.value" [duration]="duration"></p> -->
                        </div>
                    </div>
                    <p  [title]="groups[i]">{{groups[i]}}</p>
                </div>
                
            </div>
            <!-- <div class="bar-chart__chart__wrap__legend">
                <div *ngFor="let item of groups">
                     <p>{{item}}</p>
                </div>
            </div> -->
        </div>
    </div>
</div>

